module.exports = __webpack_public_path__ + "static/media/Klevra_figure.600aff13.png";